module.exports = new __parcel__URL__("product6.c538d3e6.jpg").toString();